var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTerms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666748 1.99992C0.666748 1.63173 0.965225 1.33325 1.33341 1.33325H5.33342C6.21747 1.33325 7.06532 1.68444 7.69044 2.30956C8.31556 2.93468 8.66675 3.78253 8.66675 4.66658V13.9999C8.66675 14.3681 8.36827 14.6666 8.00008 14.6666C7.63189 14.6666 7.33342 14.3681 7.33342 13.9999C7.33342 13.6463 7.19294 13.3072 6.94289 13.0571C6.69284 12.8071 6.3537 12.6666 6.00008 12.6666H1.33341C0.965225 12.6666 0.666748 12.3681 0.666748 11.9999V1.99992ZM7.33342 11.6905V4.66658C7.33342 4.13615 7.1227 3.62744 6.74763 3.25237C6.37256 2.8773 5.86385 2.66659 5.33342 2.66659H2.00008V11.3333H6.00008C6.47223 11.3333 6.93148 11.4585 7.33342 11.6905Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.30973 2.30956C8.93485 1.68444 9.78269 1.33325 10.6667 1.33325H14.6667C15.0349 1.33325 15.3334 1.63173 15.3334 1.99992V11.9999C15.3334 12.3681 15.0349 12.6666 14.6667 12.6666H10.0001C9.64646 12.6666 9.30732 12.8071 9.05727 13.0571C8.80722 13.3072 8.66675 13.6463 8.66675 13.9999C8.66675 14.3681 8.36827 14.6666 8.00008 14.6666C7.63189 14.6666 7.33342 14.3681 7.33342 13.9999V4.66658C7.33342 3.78253 7.6846 2.93468 8.30973 2.30956ZM8.66675 11.6905C9.06869 11.4585 9.52793 11.3333 10.0001 11.3333H14.0001V2.66659H10.6667C10.1363 2.66659 9.62761 2.8773 9.25253 3.25237C8.87746 3.62744 8.66675 4.13615 8.66675 4.66658V11.6905Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerms);
export default __webpack_public_path__ + "static/media/terms.11cdea1254f13fe7cc2e165cbaba51c6.svg";
export { ForwardRef as ReactComponent };